import { useState } from "react";
import BuyersTab from "./product-out/BuyersTab";
import ProductsTab from "./product-out/ProductsTab";
import DispatchesTab from "./product-out/DispatchesTab";
import ReceivablesTab from "./product-out/ReceivablesTab";
import BuyerLedger from "./product-out/BuyerLedger";
import { Ship, Cookie, FileText, Wallet } from "lucide-react";

const TABS = [
  { key: "dispatches", label: "Dispatches", icon: FileText },
  { key: "receivables", label: "Receivables", icon: Wallet },
  { key: "products", label: "Products", icon: Cookie },
  { key: "buyers", label: "Buyers", icon: Ship },
];

export default function ProductOut() {
  const [tab, setTab] = useState("dispatches");
  const [ledgerBuyerId, setLedgerBuyerId] = useState(null);

  if (ledgerBuyerId) {
    return (
      <div data-testid="product-out-page">
        <BuyerLedger buyerId={ledgerBuyerId} onBack={() => setLedgerBuyerId(null)} />
      </div>
    );
  }

  return (
    <div data-testid="product-out-page">
      <div className="eyebrow">Product Out</div>
      <h1 className="mt-2 text-4xl">Outbound dispatches &amp; buyer ledger</h1>
      <p className="mt-2 text-sm text-[hsl(var(--ink-soft))] max-w-2xl">
        Track goods leaving the kitchen — bakery, prep, or raw stock — dispatched to ships, cafés, and shops.
        Each dispatch generates a branded delivery-note PDF; payments received flow into a running per-buyer ledger.
      </p>

      <div className="mt-6 inline-flex flex-wrap gap-1 border border-[hsl(var(--rule))] bg-[hsl(var(--bg-2))] rounded-full p-1">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`product-out-tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`inline-flex items-center gap-1.5 px-4 py-1.5 text-xs uppercase tracking-wider rounded-full transition-all ${
              tab === t.key
                ? "bg-[hsl(var(--forest))] text-[hsl(var(--bg))]"
                : "text-[hsl(var(--ink-soft))] hover:text-[hsl(var(--ink))]"
            }`}
          >
            <t.icon size={13} /> {t.label}
          </button>
        ))}
      </div>

      <div className="mt-8">
        {tab === "dispatches" && <DispatchesTab />}
        {tab === "receivables" && <ReceivablesTab onViewLedger={setLedgerBuyerId} />}
        {tab === "products" && <ProductsTab />}
        {tab === "buyers" && <BuyersTab onViewLedger={setLedgerBuyerId} />}
      </div>
    </div>
  );
}
